import React from "react";
import PropTypes from "prop-types";

import LabeledContent from "@components/LabeledContent";
import { css } from "@oddcommon/utils";
import styles from "./DoubleTextAndImageBlock.module.scss";

export default function DoubleTextAndImageBlock({ first, second, layout }) {
  return (
    <div className={css(styles.base, styles[`layout-${layout}`])}>
      <div className={styles.first}>
        <LabeledContent label={first.textLabel} className={css(styles.textContainer)}>
          <div className={styles.text}>{first.text}</div>
        </LabeledContent>
        <div className={styles.imageWrapper}>
          <img
            className={styles.image}
            src={first.image.src + "?fm=webp&w=1920&q=80"}
            alt={first.image.alt}
          />
          {first.image.attribution?.trim?.() && (
            <div className={styles.attribution}>{first.image.attribution}</div>
          )}
        </div>
      </div>
      <div className={styles.second}>
        <LabeledContent label={second.textLabel} className={css(styles.textContainer)}>
          <div className={styles.text}>{second.text}</div>
          <img
            className={styles.image}
            src={second.image.src + "?fm=webp&w=1920&q=80"}
            alt={second.image.alt}
          />
          {second.image.attribution?.trim?.() && (
            <div className={styles.attribution}>{second.image.attribution}</div>
          )}
        </LabeledContent>
      </div>
    </div>
  );
}

DoubleTextAndImageBlock.propTypes = {
  first: PropTypes.shape({
    textLabel: PropTypes.node,
    text: PropTypes.node.isRequired,
    image: PropTypes.shape({
      src: PropTypes.string.isRequired,
      alt: PropTypes.string.isRequired,
      attribution: PropTypes.node,
    }).isRequired,
  }).isRequired,
  second: PropTypes.shape({
    textLabel: PropTypes.node,
    text: PropTypes.node.isRequired,
    image: PropTypes.shape({
      src: PropTypes.string.isRequired,
      alt: PropTypes.string.isRequired,
      attribution: PropTypes.node,
    }).isRequired,
  }).isRequired,
  layout: PropTypes.oneOf(["stagger-down", "stagger-up", "even"]),
};
DoubleTextAndImageBlock.defaultProps = {
  layout: "stagger-down",
};
